import { render, staticRenderFns } from "./ShowEvent.vue?vue&type=template&id=587a2573&scoped=true&"
import script from "./ShowEvent.vue?vue&type=script&lang=js&"
export * from "./ShowEvent.vue?vue&type=script&lang=js&"
import style0 from "./ShowEvent.vue?vue&type=style&index=0&id=587a2573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a2573",
  null
  
)

export default component.exports